module.exports = __webpack_public_path__ + "static/media/july 2021.f9c88314.svg";